import { Chip } from "@mui/material";
import DetailView, {
  DetailCard,
  DetailField,
  ExpirationChip,
  formatDate,
  isEmpty,
  linkValue,
  text,
  yesNo,
} from "../../Components/Shared/DetailView/DetailView";

// Ficha de un dominio, con el formato común de DetailView
export default function DomainDetail(props: { row: any }) {
  const { row } = props;
  return (
    <DetailView
      title={row.url}
      comment={row.comments}
      badges={
        <>
          {row.auto_re ? <Chip size="small" color="info" label="Autorenovación" /> : null}
          <ExpirationChip date={row.expiration_day} adviseDays={row.advise_days} />
        </>
      }
    >
      <DetailCard title="General">
        <DetailField label="URL">{linkValue(row.url)}</DetailField>
        <DetailField label="Hosting">{text(row.hosting)}</DetailField>
      </DetailCard>

      <DetailCard title="Fechas">
        <DetailField label="Emisión">{formatDate(row.emit)}</DetailField>
        <DetailField label="Vencimiento">{formatDate(row.expiration_day) ?? "Sin vencimiento"}</DetailField>
        <DetailField label="Aviso de caducidad">
          {isEmpty(row.advise_days) || Number(row.advise_days) === 0 ? null : `${row.advise_days} días antes`}
        </DetailField>
      </DetailCard>

      <DetailCard title="Renovación">
        <DetailField label="Coste de renovación">
          {isEmpty(row.cost_re) ? null : `${row.cost_re} €`}
        </DetailField>
        <DetailField label="Autorenovación">{yesNo(row.auto_re)}</DetailField>
      </DetailCard>
    </DetailView>
  );
}
